import pinia from '@/stores'
import { useDialogStore } from '@/stores/dialog'
// Utilisation
// this.$dialog.show({ message: 'Salut' })
// this.$dialog.hide()

const dialog = {
  show (data) {
    useDialogStore(pinia).showDialog(data)
  },
  hide (data) {
    useDialogStore(pinia).hideDialog()
  },
}

export default dialog
